import { useState, useEffect } from 'react'
import { toastError, toastSuccess } from '../../util/toastUtil'
import { useCustomAxios } from '../../axiosInstance'
import FormButton from '../../components/FormButton/FormButton'
import Input from '../../components/Input/Input'
import {
    Link,
    Navigate,
    useLocation,
    useNavigate,
    useSearchParams,
} from 'react-router-dom'
import Register from '../Register/Register'
import {
    LETTERREQUESTEMAIL_ENDPOINTS,
    REGISTER_ENDPOINTS,
} from '../../constants/apiConstants'
import { baseURLRoute } from '../../constants/routeConstants'
import MuiInput from '../../components/MaterialComponent/MuiInput'
import MuiButton from '../../components/MaterialComponent/MuiButton'

const Emailverify = ({ setUser, setLoadingDataGlobal }) => {
    const axios = useCustomAxios()
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()

    let flag = false
    const [email, setEmail] = useState('')
    const [code, setCode] = useState('')
    const [isfirest, setisfirest] = useState(true)
    const [loginEmailError, setLoginEmailError] = useState('')
    const [showRegister, setRegisterFlag] = useState(true)
    const [letterRequestEmailId, setLetterRequestEmailId] = useState(0)

    useEffect(() => {
        let isSubscribed = true

        const getRawQueryParams = (queryString) => {
            const params = {}
            // Split the query string on '&' and iterate over each key-value pair
            queryString.split('&').forEach((part) => {
                const equalIndex = part.indexOf('=')
                if (equalIndex === -1) {
                    return // Skip if there is no '='
                }
                // Extract key and value based on the position of '='
                const key = part.substring(0, equalIndex)
                const value = part.substring(equalIndex + 1)
                // Assign to params without decoding
                params[key] = value
            })
            return params
        }

        const rawQueryString = window.location.search.substring(1) // Remove the '?' at the start
        const rawParams = getRawQueryParams(rawQueryString)
        const requestCode = rawParams['RequestCode']

        const verifyRequestCode = async () => {
            const letterReqParams = {
                inviteCode: requestCode,
            }

            setLoadingDataGlobal(true)
            const data = await axios
                .get(LETTERREQUESTEMAIL_ENDPOINTS.LETTERREQUESTEMAIL, {
                    params: letterReqParams,
                })
                .then((response) => {
                    return response
                })
                .catch((err) => {
                    // console.log(err);
                    return err.response
                })
            if (isSubscribed) {
                if (data.status == 200) {
                    if (data.data.userId == -1) {
                        setLoadingDataGlobal(false)
                        sessionStorage.setItem(
                            'token',
                            JSON.stringify(data.data.token).slice(1, -1)
                        )
                        setLetterRequestEmailId(data.data.letterRequestEmailId)
                        setEmail(data.data.email)
                        setRegisterFlag(false)
                    } else {
                        // call the function
                        setLoadingDataGlobal(false)
                        toastError("You're already registered. Please login.")
                        navigate(baseURLRoute, { replace: true })
                    }
                } else {
                    setLoadingDataGlobal(false)
                    toastError(
                        data.data
                            ? data.data
                            : 'Something went wrong, please refresh the page and try again.'
                    )
                    // call the function
                }
            }
        }

        if (requestCode) {
            verifyRequestCode()
            // make sure to catch any error
            // .catch(console.error);
        } else {
        }

        return () => (isSubscribed = false)
    }, [])

    function ValidateEmail(mail) {
        if (/^[^@]+@[^@]+\.[^@]+$/.test(mail)) {
            return true
        }
        return false
    }

    const handleSubmitemail = async (e) => {
        e.preventDefault()

        if (!ValidateEmail(email)) {
            setLoginEmailError(true)
            return
        }
        setLoginEmailError(false)
        setLoadingDataGlobal(true)
        await axios
            .post(REGISTER_ENDPOINTS.CONFIRMEMAIL + email)
            .then((response) => {
                //get token from response
                setLoadingDataGlobal(false)
                toastSuccess(response.data)
                setisfirest(false)
            })
            .catch((err) => {
                // setEmail('')
                setLoadingDataGlobal(false)
                if (err.response) {
                    switch (err.response.data.error) {
                        case 'invalid_email':
                        case 'invalid_request':
                            toastError(err.response.data.message)
                            break
                        default:
                            toastError(
                                err.response.data.message ||
                                    'Something went wrong, please refresh the page and try again.'
                            )
                            break
                    }
                } else {
                    // Handle case where no response was received
                    toastError(
                        'Something went wrong, please refresh the page and try again.'
                    )
                }
                // console.log(err);
            })
    }
    const handleSubmitcode = async (e) => {
        e.preventDefault()

        const ePayload = {
            email: email,
            code: code,
        }

        setLoadingDataGlobal(true)

        await axios
            .post(
                REGISTER_ENDPOINTS.VERIFYSECURITYCODE + email + '&code=' + code
            )
            .then((response) => {
                const user = response.data
                //set JWT token to local
                //setAuthToken(user.accessToken);
                //sessionStorage.setItem("user", user);
                sessionStorage.setItem(
                    'token',
                    JSON.stringify(user).slice(1, -1)
                )
                // sessionStorage.setItem("user", JSON.stringify(user));
                toastSuccess('Code Verified')
                setLoadingDataGlobal(false)
                setisfirest(false)
                setRegisterFlag(false)
            })
            .catch((err) => {
                // setEmail('')
                setLoadingDataGlobal(false)

                // Handle different types of errors based on the API response
                if (err.response) {
                    switch (err.response.data.error) {
                        case 'account_exists':
                            toastError(err.response.data.message)
                            navigate(baseURLRoute, { replace: true })
                            break
                        case 'code_expired':
                        case 'invalid_attempt':
                            toastError(err.response.data.message)
                            break
                        default:
                            toastError(
                                err.response.data.message ||
                                    'Something went wrong, please refresh the page and try again.'
                            )
                            break
                    }
                } else {
                    // Handle case where no response was received
                    toastError(
                        'Something went wrong, please refresh the page and try again.'
                    )
                }
            })
    }

    return (
        <>
            <section
                className="section"
                style={{
                    padding: '0px',
                    display: 'flex',
                    justifyContent: 'center',
                }}>
                {!showRegister ? (
                    <Register
                        letterRequestEmailId={letterRequestEmailId}
                        user_email={email}
                        setLoadingDataGlobal={setLoadingDataGlobal}
                    />
                ) : isfirest ? (
                    <form
                        className="form"
                        onSubmit={handleSubmitemail}
                        style={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                        }}>
                        <h5>Valid Email Confirmation</h5>
                        <p>
                            Please enter your email and click the [Verify Email
                            Account] button to ensure the email you enter is
                            valid and you own the email address. After clicking
                            the button DO NOT close this page. You will receive
                            an email within 30 seconds with a confirmation
                            security code you will need to enter in this page
                        </p>

                        <MuiInput
                            required
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            onChange={(e) => setEmail(e.target.value)}
                            autoFocus
                            error={loginEmailError}
                            value={email}
                            helperText={loginEmailError && 'Email is not valid'}
                        />
                        <MuiButton>Verify Email Account</MuiButton>
                    </form>
                ) : (
                    <form
                        className="form"
                        onSubmit={handleSubmitcode}
                        style={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                        }}>
                        <h5>Verify Email</h5>
                        <p>
                            Please enter your security code and click the
                            [Verify Security Code] button to ensure the email
                            you enter is valid and you own the email address.
                        </p>

                        <MuiInput
                            required
                            type={'text'}
                            id="code"
                            label={'Enter Security Code'}
                            name="code"
                            onChange={(e) => setCode(e.target.value)}
                            autoFocus
                            value={code}
                        />
                        <MuiButton>Verify Security Code</MuiButton>
                    </form>
                )}
            </section>
        </>
    )
}
export default Emailverify
